import { useEffect } from 'react';
import { useChatContext } from '../context/ChatContext';
import { setMessages } from '../reducers/chat.reducer';

/**
 * Hook que fuerza la recarga de mensajes persistidos al montar el componente
 * Útil para asegurar que los mensajes se carguen en pestañas nuevas
 */
export const useChatPersistenceLoader = () => {
  const { dispatch } = useChatContext();

  useEffect(() => {
    // Función para cargar mensajes desde localStorage
    const loadPersistedMessages = () => {
      try {
        const sessionId = localStorage.getItem('chat_session_id');
        if (sessionId) {
          const savedMessages = localStorage.getItem(`chat_messages_${sessionId}`);
          if (savedMessages) {
            const messages = JSON.parse(savedMessages);
            dispatch(setMessages(messages));
          }
        }
      } catch (error) {
        console.error('Error loading persisted messages:', error);
      }
    };

    // Cargar mensajes con un pequeño delay para asegurar que el contexto esté listo
    const timeoutId = setTimeout(loadPersistedMessages, 100);

    return () => clearTimeout(timeoutId);
  }, [dispatch]);

  return null;
};

export default useChatPersistenceLoader;
